import { render, staticRenderFns } from "./PageGrantEvidence.vue?vue&type=template&id=79035600&scoped=true&"
import script from "./PageGrantEvidence.vue?vue&type=script&lang=js&"
export * from "./PageGrantEvidence.vue?vue&type=script&lang=js&"
import style0 from "./PageGrantEvidence.vue?vue&type=style&index=0&id=79035600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79035600",
  null
  
)

export default component.exports